var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 10H15C12.2386 10 10 12.2386 10 15V25C10 27.7614 12.2386 30 15 30H25C27.7614 30 30 27.7614 30 25V15C30 12.2386 27.7614 10 25 10Z",
    stroke: "#6C5CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.37C24.1234 20.2022 23.9812 21.0522 23.5937 21.799C23.2062 22.5458 22.5931 23.1514 21.8416 23.5297C21.0901 23.9079 20.2384 24.0396 19.4077 23.9059C18.5771 23.7723 17.8097 23.3801 17.2148 22.7852C16.6199 22.1902 16.2277 21.4229 16.094 20.5922C15.9604 19.7615 16.092 18.9099 16.4703 18.1584C16.8485 17.4069 17.4541 16.7937 18.2009 16.4062C18.9477 16.0187 19.7977 15.8766 20.63 16C21.4789 16.1259 22.2648 16.5215 22.8716 17.1283C23.4785 17.7351 23.8741 18.5211 24 19.37Z",
    stroke: "#6C5CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 14,
    r: 0.5,
    stroke: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.fef4c4ebf301356b9f91fc8d804aa044.svg";
export { ForwardRef as ReactComponent };